import { useState } from "react";

function Contact() {
    const [formData, setFormData] = useState({
        name: "",
        phone: "",
        email: "",
        booksDonated: "",
        serviceType: "",
        comments: ""
    });

    const [status, setStatus] = useState({
        text: "",
        type: "info"
    });

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData(prev => ({
            ...prev,
            [name]: value
        }));

        // Mutual restriction: reset conflicting values
        if (name === "booksDonated") {
            if (value === "1-50" && formData.serviceType === "pickup") {
                setFormData(prev => ({ ...prev, serviceType: "" }));
                alert("Pickup is only available for 100+ books.");
            }
        }

        if (name === "serviceType") {
            if (value === "pickup" && formData.booksDonated === "1-50") {
                setFormData(prev => ({ ...prev, booksDonated: "" }));
                alert("Pickup is only available for 100+ books.");
            }
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.serviceType || !formData.booksDonated) {
            setStatus({ text: "Please select number of books and service type.", type: "error" });
            return;
        }

        setStatus({ text: "Sending...", type: "info" });

        try {
            const response = await fetch("/api/schedule", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(formData)
            });

            if (!response.ok) throw new Error("Failed to submit");

            setStatus({ text: "Donation request submitted! Thank you.", type: "success" });
            setFormData({
                name: "",
                phone: "",
                email: "",
                booksDonated: "",
                serviceType: "",
                comments: ""
            });
        } catch (error) {
            setStatus({ text: "Something went wrong. Please try again.", type: "error" });
        }
    };

    // Determine what to disable
    const disablePickup = formData.booksDonated === "1-50";
    const disableSmallBooks = formData.serviceType === "pickup";

    return (
        <section className="contact" id="contact">
            <div className="contact-title">
                <h1>Contact</h1>
            </div>
            <div className="wrapper">
                <div className="contact-info">
                    <div className="map-wrapper">
                        <iframe
                            title="Bucks County Map"
                            src="https://www.google.com/maps?q=Bucks+County,+PA&output=embed"
                            style={{ border: 0 }}
                            allowFullScreen=""
                            loading="eager"
                            referrerPolicy="no-referrer-when-downgrade"
                        />
                    </div>
                    <div className="contact-info-content">
                        <ul className="contact-info-list">
                            <li className="contact-info-item">
                                Telephone: <a href="tel:+12678894563">+1 (267) 889-4563</a>
                            </li>
                            <li className="contact-info-item">
                                Email: <a href="mailto:tycassid@icloud.com">tycassid@icloud.com</a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="contact-form">
                    <div className="form-intro">
                        <h3>Schedule a Drop-off or Pickup</h3>
                        <p>
                            Send us your contact information and we’ll reach out to you
                            shortly to coordinate and schedule your event.
                        </p>
                        <p>
                            <b>NOTE:</b> pickup is only available for 100+ books.
                        </p>
                    </div>

                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <input
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                required
                                placeholder="Name"
                            />
                        </div>

                        <div className="form-group">
                            <input
                                type="tel"
                                name="phone"
                                value={formData.phone}
                                onChange={handleChange}
                                required
                                placeholder="Phone Number"
                            />
                        </div>

                        <div className="form-group">
                            <input
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                                placeholder="Email Address"
                            />
                        </div>

                        {/* Number of books first */}
                        <div className="form-group">
                            <select
                                name="booksDonated"
                                value={formData.booksDonated}
                                onChange={handleChange}
                                required
                            >
                                <option value="" disabled>
                                    Approximate Number of Books
                                </option>
                                <option value="1-50" disabled={disableSmallBooks}>
                                    1-50
                                </option>
                                <option value="50-200">50-200</option>
                                <option value="200+">200+</option>
                            </select>
                        </div>

                        {/* Service type second */}
                        <div className="form-group">
                            <select
                                name="serviceType"
                                value={formData.serviceType}
                                onChange={handleChange}
                                required
                            >
                                <option value="" disabled>
                                    Donation Type
                                </option>
                                <option value="dropoff">Drop-off</option>
                                <option value="pickup" disabled={disablePickup}>
                                    Pickup
                                </option>
                            </select>
                        </div>

                        <div className="form-group">
                            <textarea
                                name="comments"
                                value={formData.comments}
                                onChange={handleChange}
                                rows="4"
                                placeholder="Additional Comments"
                            />
                        </div>

                        <button type="submit">Schedule</button>

                        <p className={`form-status ${status.type}`}>
                            {status.text}
                        </p>
                    </form>
                </div>
            </div>
        </section>
    );
}

export default Contact;
